'use strict';

/**
 * Chart Header Directive
 *
 * It's a wrapper for chart header. It can contains for ex. one of chart legends directive or any custom code.
 *
 * @constructor
 */
var ChartHeaderDirective = function ChartHeaderDirective() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: require('../templates/chart-header.html'),
    /**
     * @param {Object} scope
     * @param {string} scope.title - chart's title
     * @param {Function} scope.resetChartHandler - handler for chart reset
     * @param {(string[]|Object[])} scope.metricItems - array metric combobox items
     * @param {(string|Object)} scope.selectedMetric - metric ng-model
     * @param {Function} scope.metricChangeHandler - on metric change handler
     */
    scope: {
      rmTitle: '@',
      // reset
      resetChartHandler: '=',
      // metric
      metricItems: '=',
      selectedMetric: '=',
      metricChangeHandler: '=',
      cogMenu: '=?'
    },
    link: function link(scope) {
      scope.localMetricChangeHandler = function () {
        scope.metricChangeHandler(scope.selectedMetric);
      };
      scope.isTitleVisible = function () {
        return scope.rmTitle || scope.resetChartHandler;
      };
    }
  };
};
ChartHeaderDirective.$inject = [];
module.exports = ChartHeaderDirective;